/** Display labels for supplier_type (API: rental | sale | hybrid). */
export function scaffoldingTypeBadges(supplierType) {
  const key = (supplierType || "hybrid").toLowerCase();
  if (key === "rental") return ["Scaffolding rental"];
  if (key === "sale") return ["Scaffolding sale"];
  if (key === "hybrid") return ["Scaffolding sale", "Scaffolding rental"];
  const raw = String(supplierType || "").trim();
  return raw ? [raw.replace(/_/g, " ")] : ["—"];
}
